export { default } from './IsMobileCell';
